import { PiletApi } from '@sharefiledev/sharefile-appshell';

export enum NotificationType {
	reminder = 'Reminder',
	comment = 'Comment',
	statusUpdate = 'Status Update',
}

export interface NotificationCenterProps {
	mainDrawerState: boolean;
	settingsDrawerState: boolean;
	setMainDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
	setSettingsDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface ExtensionProps {
	app: PiletApi;
}
export interface Preference {
	type: string;
	enabled: boolean;
}
export interface PreferenceDto {
	preference: {
		enabled: boolean;
		preferences: Preference[];
	};
}

export interface UpdatedPreferenceDto {
	updatedPreference: {
		enabled: boolean;
		preferences: Preference[];
	};
}

export interface NovuConfiguration {
	serviceUrls: {
		webSocketUrl: string;
		apiUrl: string;
	};
	appIdentifier: string;
	hmac: string;
}

export const PAGE_SIZE = 10;
